import $ from 'jquery';
import 'slick-carousel';
import { isRTL } from '../../utils/rtl';

const $slider = $('#promotions-slider');
const $wrapper = $slider.closest('.promotionsSliderWrapper');
const slidesToShowRaw = Number($slider.data('slides-to-show'));
const slidesToShow = slidesToShowRaw === 1 ? 1 : 2;

if ($slider.length) {
    $slider.one('init', () => {
        $slider.css('visibility', 'visible');
        $wrapper.removeClass('slickLoading');
    });

    $slider.slick({
        infinite: true,
        autoplay: false,
        dots: false,
        slidesToShow,
        slidesToScroll: slidesToShow,
        prevArrow:
            "<button type='button' class='arrow-prev pull-left mr-2 arrow-style'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow:
            "<button type='button' class='arrow-next pull-right arrow-style'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        appendArrows: $('.promotion-arrows'),
        touchThreshold: 1000,
        responsive: [
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow,
                    slidesToScroll: slidesToShow,
                    arrows: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
        ],
        rtl: isRTL(),
    });
}
